import { ReactNode } from 'react';

import { useBelow } from '../../hooks/useBreakpoint';
import { Breakpoint } from '../../styles/media';
import { belowStyles } from '../../styles/responsive.css';

interface BelowProps {
    bp: Breakpoint;
    children: ReactNode;
    avoidRendering?: boolean;
}

function BelowWithMatchMedia({ bp, children }: { bp: Breakpoint; children: ReactNode }) {
    const matches = useBelow(bp);
    return matches ? children : null;
}

export function Below({ bp, children, avoidRendering = false }: BelowProps) {
    // Use matchMedia to avoid rendering if avoidRendering is true
    if (avoidRendering) {
        return <BelowWithMatchMedia bp={bp}>{children}</BelowWithMatchMedia>;
    }

    // Use CSS to hide/show (always renders)
    return <div className={belowStyles[bp]}>{children}</div>;
}
